import { render, staticRenderFns } from "./WizardHeader.vue?vue&type=template&id=09405a25&scoped=true&"
import script from "./WizardHeader.vue?vue&type=script&lang=js&"
export * from "./WizardHeader.vue?vue&type=script&lang=js&"
import style0 from "./WizardHeader.vue?vue&type=style&index=0&id=09405a25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09405a25",
  null
  
)

export default component.exports